import styled from '../../../styles/theme';
import { CheckoutMySummaryStyled } from '../CheckoutMySummaryStyled';
import { CheckoutMySummaryProps } from '../index';

export const CheckoutMySummaryStyledAP = styled(CheckoutMySummaryStyled)`
    .grid {
        & > .Collapsible {
            ${prop =>
                (prop as CheckoutMySummaryProps).isMyOrderPage
                    ? {
                          borderTop: 'none',
                          background: 'unset',
                      }
                    : {}};
            font-size: ${({ theme }) => theme.fontSizes.textBase};

            .chars {
                ${prop =>
                    (prop as CheckoutMySummaryProps).isMyOrderPage
                        ? {
                              padding: '0',
                          }
                        : {}};
            }

            & > .Collapsible__trigger {
                ${prop =>
                    (prop as CheckoutMySummaryProps).isMyOrderPage
                        ? {
                              width: '200px',
                              fontWeight: 'bold',
                              padding: '15px 25px',
                              border: '1px solid #000000',
                              background: '#FFFFFF',
                              margin: '20px',
                              'text-transform': 'unset',
                          }
                        : {}};
                &::after {
                    ${prop =>
                        (prop as CheckoutMySummaryProps).isMyOrderPage
                            ? {
                                  display: 'none',
                              }
                            : {}};
                }
                &:hover {
                    ${prop =>
                        (prop as CheckoutMySummaryProps).isMyOrderPage
                            ? {
                                  'border-color': '#00A3E0',
                                  color: '#00A3E0',
                              }
                            : {}};
                }
                &.is-open {
                    ${prop =>
                        (prop as CheckoutMySummaryProps).isMyOrderPage
                            ? {
                                  color: '#000000',
                                  border: '1px solid #000000',
                              }
                            : {}};
                }
            }
            & > .Collapsible__contentOuter {
                ${prop =>
                    (prop as CheckoutMySummaryProps).isMyOrderPage
                        ? {
                              background: '#FFFFFF',
                          }
                        : {}};
            }
        }
    }
`;
